import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { Navigate } from 'react-router';

import Layout from './Layout';
import Login from './Auth/Login';
import Callback from './Auth/Callback';
import Logout from './Auth/Logout';
import ProtectedRoute from './ProtectedRoute';
import ErrorPage from './shared/ErrorPage';
import Organizations from './Organizations';
import OrganizationForm from './Organizations/OrganizationForm';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: (
          <ProtectedRoute accqsure>
            <Navigate to='/organizations' replace />
          </ProtectedRoute>
        ),
        children: [],
      },
      {
        path: '/organizations',
        element: (
          <ProtectedRoute accqsure>
            <Organizations />
          </ProtectedRoute>
        ),
        children: [],
      },
      {
        path: '/organizations/edit',
        element: (
          <ProtectedRoute accqsure>
            <OrganizationForm />
          </ProtectedRoute>
        ),
        children: [],
      },
      {
        path: '/login',
        element: <Login />,
        children: [],
      },
      {
        path: '/logout',
        element: <Logout />,
        children: [],
      },
      {
        path: '/authenticate',
        element: <Callback />,
        children: [],
      },
      {
        path: '/error',
        element: <ErrorPage />,
        children: [],
      },
      {
        path: '*',
        element: <ErrorPage />,
        children: [],
      },
    ],
  },
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
